import React from "react";

export default function Switch({ id, checked, onChange, label, disabled }) {
  return (
    <label className="ui-switch" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="ui-switch__input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="ui-switch__track" aria-hidden="true">
        <span className="ui-switch__knob" />
      </span>
      <span className="ui-switch__label">{label}</span>
    </label>
  );
}
